import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import BookDataService from "../../../services/BookService";
import CreatorService from "../../../services/CreatorService";
import CategoryDataService from "../../../services/CategoryService";
import { useHistory } from "react-router-dom";
import CustomYesNoModal from "../../micro_components/CustomYesNoModal";

export default function ButtonBar({
  isNew,
  id,
  selectedCategories,
  book,
  setBook,
  isPublishing,
  roles,
  existingBookId,
  bookCover,
  description,
  setLoading,
}) {
  const [cloneModalOpen, setCloneModalOpen] = useState(false);
  const history = useHistory();

  const addRoles = async (id) => {
    // Skip blank/sentinel rows so we never POST creator_id: 0 or empty
    const validRoles = (roles || []).filter((role) => {
      const creatorId = Number(role.creator_id);
      return role.creator_id !== "" && role.creator_id != null && creatorId > 0;
    });

    CreatorService.addRolesForBook(id, validRoles)
      .then((response) =>
        console.log("uploaded roles for new book: ", response)
      )

      .catch((e) => {
        console.log("error uploading roles: " + e);
      });
  };

  const uploadBookDescription = async (id) => {
    const data = new FormData();

    // const element = document.createElement("a");
    const file = new Blob([description], { type: "text/plain" });

    data.append("file", file);

    BookDataService.uploadBookDescription(id, data)
      .then((response) => console.log(response.data))
      .catch((e) => {
        console.log("error uploading description: " + e);
      });
  };

  const saveNewBookCover = async (id) => {
    setLoading(true);
    console.log("saving book cover!");
    BookDataService.postCoverImage(id, bookCover)
      .then((response) => {
        setLoading(false);
        console.log(response);
        // history.push("/books");
      })
      .catch((e) => {
        console.log("error posting book cover" + e);
      });
  };

  // SAVE BOOK COVER
  const saveBookCover = () => {
    setLoading(true);
    console.log("saving book cover!");

    BookDataService.postCoverImage(book.id, bookCover)
      .then((response) => {
        console.log(
          "🚀 ~ file: MaterialAddBook.jsx:455 ~ .then ~ response:",
          response
        );
        setLoading(false);

        // console.log(response);
        // history.push("/books");
      })
      .catch((e) => {
        console.log("error posting book cover" + e);
      });
  };

  const saveBook = () => {
    console.log("saving book...");
    const dataForBook = {
      title: book.title,
      domain_id: parseInt(book.domain_id),
      language: book.language,
      active: book.active,
      commentary: book.commentary,
      score: book.score,
      difficulty: book.difficulty,
      sampleVideoLink: book.sampleVideoLink,
      primary_color: book.primary_color,
      secondary_color: book.secondary_color,
      third_party_PDF_store: book.third_party_PDF_store,
      dpi_PDF_link: book.dpi_PDF_link,
      bookPin: book.bookPin,
      pdf_coupon: book.pdf_coupon,
      menuWidth: book.menuWidth,
      chapterThumbHeight: book.chapterThumbHeight,
      pageThumbHeight: book.pageThumbHeight,
      chapterTextMaxWidth: book.chapterTextMaxWidth,
      chapterTextFontSize: book.chapterTextFontSize,
      hideGradient: book.hideGradient,
    };

    // console.log("saving data book: ", dataForBook);
    // console.log("roles: ", roles);

    //when book is created, use its id to make relations with categories
    const updateCategories = async (id) => {
      let cat_ids = selectedCategories.map((c) => {
        return c.id;
      });

      // console.log("sending categories: " + JSON.stringify(cat_ids));

      CategoryDataService.updateBookCategories(id, cat_ids)
        .then((response) => {
          // console.log(response);
        })
        .catch((e) => {
          console.log("error uploading categories: " + e);
        });

      // history.push("/books");
    };

    if (isNew) {
      console.log("BOOK IS NEW");
      console.log(dataForBook);
      BookDataService.create(dataForBook)
        .then(async (response) => {
          console.log("response from creating: ", response.data);
          await updateCategories(response.data.id);
          await addRoles(response.data.id);
          await uploadBookDescription(response.data.id);
          await saveNewBookCover(response.data.id);
          const idForRedirectRefresh = response.data.id;

          if (isPublishing) {
            dataForBook.publisher = book.publisher;
            dataForBook.price = book.price;
            dataForBook.type = book.type;
            dataForBook.revenue = book.revenue;
            dataForBook.publishingVideo = book.publishingVideo;

            const creatorRevenues = {};
            roles.forEach(
              (role) =>
                (creatorRevenues[role.creator_id] =
                  book[`creator${role.creator_id}`])
            );

            const pubData = {
              publisher: book.publisher,
              price: book.price,
              type: book.type,
              revenue: book.revenue,
              sampleVideo: book.publishingVideo,
              creatorRevenues,
            };

            console.log("PUBDATA BRU");
            console.log(pubData);
            const response = await BookDataService.addToPublishing(
              idForRedirectRefresh,
              pubData
            );

            console.log("RESPONSE FROM ADD TO PUBLISHING");
            console.log(response);
          }
          history.push(`/books/${idForRedirectRefresh}`);
        })
        .catch((e) => console.log("error saving book details: " + e));
    } else {
      updateCategories(existingBookId);
      addRoles(existingBookId);
      uploadBookDescription(existingBookId);

      BookDataService.update(existingBookId, book)
        .then((response) => {
          console.log(response);
          setBook(response.data);

          if (isPublishing) {
            dataForBook.publisher = book.publisher;
            dataForBook.price = book.price;
            dataForBook.type = book.type;
            dataForBook.revenue = book.revenue;
            dataForBook.publishingVideo = book.publishingVideo;

            const creatorRevenues = {};
            roles.forEach(
              (role) =>
                (creatorRevenues[role.creator_id] =
                  book[`creator${role.creator_id}`])
            );

            const pubData = {
              publisher: book.publisher,
              price: book.price,
              type: book.type,
              revenue: book.revenue,
              sampleVideo: book.publishingVideo,
              creatorRevenues,
            };

            BookDataService.addToPublishing(existingBookId, pubData);
          }
        })
        .catch((e) => {
          console.log("error updating book: " + e);
        });
    }

    if (bookCover && !isNew) {
      saveBookCover();
    }

    //after save, go to home
    // history.push("/books");
  };

  useEffect(() => {
    console.log("BOOK FROM BUTTON BAR: ", book);
  }, [book]);

  // DELETE BOOK
  const deleteBook = () => {
    console.log("deleting book...");
    if (
      window.confirm("Are you sure you want to delete + " + book.title + "?")
    ) {
      BookDataService.remove(book.id)
        .then((response) => {
          history.push("/books");
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  function openCloneModal() {
    setCloneModalOpen(true);
  }

  function closeCloneModal() {
    setCloneModalOpen(false);
  }

  function cloneBook() {
    BookDataService.cloneBook(id);
  }

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={saveBook}
        startIcon={<SaveIcon />}
      >
        {isNew ? "Create Book" : "Save Changes"}
      </Button>
      {!isNew && (
        <>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={deleteBook}
            style={{
              marginLeft: "10px",
            }}
            startIcon={<DeleteIcon />}
          >
            Delete Book
          </Button>
          <Button
            onClick={openCloneModal}
            variant="contained"
            color="secondary"
            size="large"
            style={{
              marginLeft: 15,
            }}
          >
            Clone Book
          </Button>
        </>
      )}
      <CustomYesNoModal
        title={"Clone book?"}
        isOpen={cloneModalOpen}
        onClose={closeCloneModal}
        onSubmit={cloneBook}
        initial={""}
      />
    </div>
  );
}
